<template>
    <ul class="navi-group">
        <li class="navi-item nav-heading rounded">Umsatz steigern</li>
        <li class="nav-item" @click="toggleMenu"><router-link :to="{name: 'umsatz-zusatzleistung'}" class="nav-link" exact>Zusatzleistungen</router-link></li>
        <li class="nav-item" @click="toggleMenu"><router-link :to="{name: 'umsatz-banner'}"         class="nav-link" exact>Bannerwerbung</router-link></li>
        <li class="nav-item" @click="toggleMenu"><router-link :to="{name: 'kontakt-anfrage'}"       class="nav-link" exact>Beratung anfordern</router-link></li>
    </ul>
</template>

<script>
    import { ToggleMenuMixin } from '../../../mixins/ToggleMenu';

    export default {
        mixins: [ToggleMenuMixin]
    }
</script>

<style scoped>

</style>
